(ns machtfit.company-editor-styles
  "Shared Tailwind class-recipe vectors for the company-detail editor islands.")

(def card
  ["overflow-hidden" "rounded-2xl" "border" "border-gray-100" "bg-white" "shadow-xs"])

(def th
  ["whitespace-nowrap" "bg-gray-25" "px-4" "py-3" "text-left" "text-xs" "font-semibold"
   "uppercase" "tracking-wide" "text-aquafitblue-700"])

(def td
  ["px-4" "py-4" "align-top" "text-sm" "text-gray-700"])

(def reorder-button
  ["inline-flex" "size-8" "cursor-pointer" "items-center" "justify-center" "rounded-lg" "border"
   "border-gray-200" "bg-white" "text-gray-500" "transition-colors" "hover:bg-gray-50" "hover:text-gray-700"])

(def primary-button
  ["inline-flex" "items-center" "gap-2" "rounded-lg" "bg-brand-500" "px-4" "py-2.5" "text-sm"
   "font-semibold" "text-white" "shadow-xs" "transition-colors" "hover:bg-brand-600"
   "disabled:cursor-not-allowed" "disabled:opacity-60"])

(def ghost-button
  ["inline-flex" "cursor-pointer" "items-center" "gap-2" "rounded-lg" "border" "border-gray-300"
   "bg-white" "px-3.5" "py-2" "text-sm" "font-semibold" "text-gray-700" "transition-colors" "hover:bg-gray-50"])

(def edit-action
  ["inline-flex" "cursor-pointer" "items-center" "rounded-lg" "border" "border-gray-300" "bg-white"
   "px-3" "py-1.5" "text-sm" "font-semibold" "text-gray-700" "transition-colors" "hover:bg-gray-50"])

(def done-action
  ["inline-flex" "cursor-pointer" "items-center" "rounded-lg" "bg-brand-500" "px-3" "py-1.5" "text-sm"
   "font-semibold" "text-white" "shadow-xs" "transition-colors" "hover:bg-brand-600"])

(def delete-action
  ["inline-flex" "cursor-pointer" "items-center" "rounded-lg" "border" "border-error-200" "bg-white"
   "px-3" "py-1.5" "text-sm" "font-semibold" "text-error-600" "transition-colors" "hover:bg-error-25"])

(defn arrow-icon [down?]
  [:svg {:width 16 :height 16 :viewBox "0 0 24 24" :fill "none" :stroke "currentColor"
         :stroke-width 2 :stroke-linecap "round" :stroke-linejoin "round" :aria-hidden true}
   (if down?
     [:<> [:line {:x1 12 :y1 5 :x2 12 :y2 19}] [:polyline {:points "19 12 12 19 5 12"}]]
     [:<> [:line {:x1 12 :y1 19 :x2 12 :y2 5}] [:polyline {:points "5 12 12 5 19 12"}]])])
